export const load = () => ({
	title: 'Customer Testimonials on Commercial Storm Windows',
	showTitle: true,
});
